import { api } from 'store/api/strapiService';

export const analyticsController = api.injectEndpoints({
  endpoints: (build) => ({
    getAnalyticsSelections: build.query({
      query: () => ({
        url: '/api/analytics-selections',
        params: {
          populate: 'categories.games',
        },
      }),
    }),
  }),
});

export const { useGetAnalyticsSelectionsQuery } = analyticsController;
